module.exports = __webpack_public_path__ + "img/2f89df968ac3c1c518ddedfce24c6075.png";